// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"66ce7650","282":"a9b682eb","484":"0955e990"}[chunkId] + ".chunk.css";
};